import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';

import FleetAircraftList, { FleetAircraft } from '@shared/components/FleetAircraftList';
import classes from './FleetAircraftAccordion.module.scss';

export interface FleetAccordionPanel {
  key: string;
  title: string;
  aircraft: FleetAircraft[];
  expanded?: boolean;
}

interface FleetAircraftAccordionProps {
  panels: FleetAccordionPanel[];
  onAircraftClick?: (aircraft: FleetAircraft) => void;
}

const FleetAircraftAccordion = ({ panels, onAircraftClick }: FleetAircraftAccordionProps): JSX.Element => (
  <div className={classes.fleetAircraftAccordion}>
    <PanelBar>
      {panels.map((panel) => (
        <PanelBarItem key={panel.key} title={panel.title} expanded={panel.expanded}>
          <div className="content">
            <FleetAircraftList aircraft={panel.aircraft} onAircraftClick={onAircraftClick} />
          </div>
        </PanelBarItem>
      ))}
    </PanelBar>
  </div>
);

export default FleetAircraftAccordion;
